export default (key: string): string => {
	return key?.replace(/[\.\s,]/gim, '');
};
